import { useMutation } from '@tanstack/react-query';
import { useRequestSections } from '../api/request';
import { useSelector } from 'react-redux';
import { RootState } from '../redux/Store';
import { useFindPermissions } from '../utils/helpers/useFindPermissions';
import Notifications from '../ui/molecules/toast/Notifications';
import { useNavigate } from 'react-router';

const useWorkOrderSubmission = () => {
  const { Submission } = useRequestSections();
  const navigate = useNavigate();
  const { canViewSubmissions } = useFindPermissions();

  const {
    mutateAsync: getWorkOrderSubmissions,
    data: getWorkOrderSubmissionsResults,
    isPending: getWorkOrderSubmissionsPending,
    isSuccess: getWorkOrderSubmissionsSuccessful,
    isError: getWorkOrderSubmissionsError,
  } = useMutation({
    mutationFn: async (parameter: string) => {
      if (!canViewSubmissions) {
        return Notifications(
          'You do not have permission to view work order submissions',
          0
        );
      }

      try {
        const response = await Submission?.getWorkorderSubmissions(parameter);

        return response?.data;
      } catch (error: any) {
        console.log('Error occurred', error);
        Notifications('Unable to load the work order', 0);
        navigate('/home');
      }
    },
  });

  return {
    getWorkOrderSubmissions,
    getWorkOrderSubmissionsResults,
    getWorkOrderSubmissionsPending,
    getWorkOrderSubmissionsSuccessful,
    getWorkOrderSubmissionsError,
  };
};

export default useWorkOrderSubmission;
